export enum PortalServiceTileEvents {
    ClickedService = 'PortalServiceTileEvents.ClickedService',
}

type ServiceClickedPayload = {
    service: string;
    location: 'more' | 'waffle' | 'nav';
};

export interface PortalServiceTileEventMap {
    [PortalServiceTileEvents.ClickedService]: ServiceClickedPayload;
}
